import React, { useEffect } from 'react';
import '../styles/pantallaInicial.css';
import letreroPrincipal from '../imgs/otros/Letrero principal reocortado.png';
import LogosUDEA from '../components/LogosUDEA';

export default function PantallaInicio() {

    useEffect(() => {
        fetch('https://backend-escalera-udea.onrender.com/api/sesiones')
        .then(response => response.json())
    },[]);
    return (
        <div className="pInicial__div--container">
            <div>
                <img className="pInicial__div--letrero-principal" src={letreroPrincipal} alt="letrero-principal.jpg"/>
            </div>
            <LogosUDEA componente="logos-udea"/>
        </div>
    )
}
